import {
  DealBoardId,
  DealStatusStageMappingData,
  DealStatusStageMappingId,
  DealStatusStageMappingResponse,
} from '@business/entities/deal';
import { Endpoint } from '@business/api/endpoint';

export function fetchMappings(boardId?: DealBoardId) {
  return Endpoint.get<DealStatusStageMappingResponse[]>(`@gc/deal-status-stage-mappings`, {
    params: boardId ? { boardId } : {},
  });
}

export function createMapping(data: DealStatusStageMappingData) {
  return Endpoint.post<DealStatusStageMappingResponse>(`@gc/deal-status-stage-mappings`, { data });
}

export function updateMapping(id: DealStatusStageMappingId, data: Partial<Pick<DealStatusStageMappingData, 'stageId' | 'active'>>) {
  return Endpoint.patch<DealStatusStageMappingResponse>(`@gc/deal-status-stage-mappings/${id}`, { data });
}

export function deleteMapping(id: DealStatusStageMappingId) {
  return Endpoint.delete<{ success: boolean }>(`@gc/deal-status-stage-mappings/${id}`);
}
